import { useMemo } from 'react'

export function usePricing(
  largeur: number,
  computePrice: number,
  optionProgression: boolean
) {
  const nbCam = Math.max(1, Math.round(largeur / 60))

  const pricing = useMemo(() => {
    const PRIX_CAMERA_EUR = 530
    const PRIX_CARTE_EUR = 460
    const TAUX_EUR_TND = 4.862

    const totalEur = nbCam * PRIX_CAMERA_EUR + PRIX_CARTE_EUR
    let totalTnd = totalEur * TAUX_EUR_TND + 250 + computePrice
    if (optionProgression) totalTnd += 1500

    return { eur: totalEur, tnd: totalTnd }
  }, [nbCam, computePrice, optionProgression])

  return { nbCam, ...pricing }
}
